import { useIsMutating } from '@tanstack/react-query'

const GlobalMutateLoader = () => {
  const isMutating = useIsMutating()

  return (
    !!isMutating && (
      <div
        data-testid="global-mutate-loader"
        className="fixed inset-0 z-99 flex items-center justify-center bg-black/50"
      >
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-white border-t-transparent" />
      </div>
    )
  )
}

export default GlobalMutateLoader
